import {userIdentityHelper} from "../../helpers/userIdentityHelper";
import {projectValidationHelper} from "../../helpers/projectValidationHelper";
import {formatHelper} from "../mixins/formatHelper";
export class ValidationBehavior {

    static address(project) {
        let errors = [];

        return { valid: (errors.length === 0), errors: ValidationBehavior.objectToStringErrors(errors) }
    }
    static simulate(financeForm) {
        let errors = []
        if (financeForm.qualification === undefined || financeForm.qualification === null)
            errors.push("El campo calificación final es requerido")
        if (financeForm.total_cost === '' || financeForm.total_cost === null || financeForm.total_cost == 0)
            errors.push("El total de la factura es requerido")
        if (financeForm.deposit_percentage === '' || financeForm.deposit_percentage === null)
            errors.push("El enganche es requerido")
        if (financeForm.term === '' || financeForm.term === null)
            errors.push("El plazo es requerido")
        if (financeForm.annual_interest_percentage === '' || financeForm.annual_interest_percentage === null || financeForm.annual_interest_percentage == 0)
            errors.push("La tasa de interés no puede ser 0")

        return { valid: (errors.length == 0), errors }
    }
    static general(project) {
        let errors = []

        if (project.alias == null || project.alias == "")
            errors.push("El campo alias de proyecto es requerido")
        if (project.description == null || project.description == "")
            errors.push("El campo descripcion de proyecto es requerido")


        return { valid: (errors.length == 0), errors: ValidationBehavior.objectToStringErrors(errors) }
    }

    static publicProject(project) {
        let errors = []

        // Validar contratos del grupo 1
        // if (project.contracts && project.contracts.length > 0) {
        //     for (const c of project.contracts) {
        //         if (c.contract_group_id != null && (c.contract_group_id == 1 || c.contract_group_id == 2) && (c.status == "generated" || c.status == "canceled")) {
        //             errors.push(`Algunos contratos del grupo ${c.group.name} deben estar en status <<SENT>> o <<SIGNED>> para ser publicados y se encuentra en status <<${c.status}>>`);
        //             break;
        //         }
        //     }
        // }
        // se comenta por peticion en ticket ST-1839
        // else {
        //     errors.push("No se han generado los contratos para este proyecto.");
        // }
            
        if (project.description == null || project.description == "")
            errors.push("El campo descripcion de proyecto es requerido")
        // if (project.supplier.id == null || project.supplier.id == "")
        //     errors.push("Debe asignar un proveedor para continuar")
        if (project.alias == null || project.alias == "")
            errors.push("El alias del proyecto es un campo requerido")
        if (project.finance.qualification == null || project.finance.qualification == "")
            errors.push("Asigne la clasificacion final de proyecto")
        if (project.finance.total_cost <= 0)
            errors.push("El campo factura es requerido")

        if (project.finance.finance_type == null)
            errors.push("El campo tipo financiamiento es requerido")
        if (project.finance.deposit_percentage < 0)
            errors.push("El campo enganche es requerido")
        if (project.finance.term <= 0)
            errors.push("El campo plazo es requerido")
        // if (project.finance.first_payment_date == "")
        //     errors.push("El campo fecha de primer pago es requerido")


        // if(project.contracts){
        //     for (const c of project.contracts) {
        //         if(c.contract_group_id != null && (c.contract_group_id == 1 || c.contract_group_id == 2) && c.status != "sent" && c.status != "signed" && c.status != "verified") {
        //             errors.push(`Algunos contratos del grupo ${c.group.name} deben estar en status <<SENT>> o <<SIGNED>> para ser publicados y se encuentra en status <<${c.status}>>`);
        //             break;
        //         }
        //     }
        // }

        return { valid: (errors.length === 0), errors: ValidationBehavior.objectToStringErrors(errors) }
    }
    static approve(project) {
        let errors = []

        // if (project.supplier.id == null || project.supplier.id == "")
        //     errors.push("Debe asignar un proveedor para continuar")
        if (project.finance.qualification == null || project.finance.qualification == "")
            errors.push("Asigne la clasificacion final de proyecto")
        if (project.finance.total_cost <= 0)
            errors.push("El campo factura es requerido")
        if (project.finance.qualification === "" || project.finance.qualification === null)
            errors.push("El campo calificación final es requerido")
        if (project.finance.finance_type === null)
            errors.push("El campo tipo financiamiento es requerido")
        if (project.finance.deposit_percentage < 0)
            errors.push("El campo enganche es requerido")
        if (project.finance.term <= 0)
            errors.push("El campo plazo es requerido")
        // if (project.finance.credit_acceptance_date == null)
        //     errors.push("El campo Aceptación de crédito es requerido")
        // if (project.documentation_complete_date == null)
        //     errors.push("El campo Documentación completa es requerido")
        // if (project.loan_proposal_timestamp == null)
        //     errors.push("El campo Oferta realizada es requerido")
        // if (project.loan_review_request_timestamp == null)
        //     errors.push("El campo Revisión sin documentos es requerido")

        // Sí es un loan_type 1, sólo valida la Documentación completa
        if(project.finance.loan_type == 1){
            if (project.documentation_complete_date == null) 
                errors.push("El campo Documentación completa es requerido")
        } else {
            if (project.loan_review_request_timestamp == null)
                errors.push("El campo Revisión sin documentos es requerido")

            if (project.documentation_complete_date == null) 
                errors.push("El campo Documentación completa es requerido")
        }

        return { valid: (errors.length === 0), errors: errors }
    }

    static objectToStringErrors(errors) {
        let errorStr = "";
        if (errors.length > 0) {
            errors.forEach(err => {
                errorStr += err + "\n";
            });
        }

        return errorStr
    }
}
